<div [workUiPopoverPosition]="dropdownPosition()"
     [workUiPopoverTrigger]="popoverTrigger()"
     [workUiPopover]="popoverTemplate"
     [(workUiPopoverVisible)]="dropDownOpen"
     class="work-ui-actions-dropdown-button">
  <work-ui-button [disabled]="dropdownOptions() && !dropdownOptions().length || disabled()"
                  [iconName]="iconName()"
                  [iconOnly]="buttonText() === ''"
                  [iconPositionRight]="iconPositionRight()"
                  [size]="buttonSize()"
                  [style.pointer-events]="popoverTrigger() === 'hover' ? 'none' : 'initial'"
                  [text]="buttonText()"
                  [tooltipDescription]="tooltipDescription()"
                  [variant]="buttonVariant()"
                  [whiteBackground]="buttonWhiteBackground()" />
  <ng-template #popoverTemplate>
    <work-ui-dropdown-list #actionsDropdown
                           (optionSelected)="selectAction($event)"
                           [(dropDownOpen)]="dropDownOpen"
                           [listTitle]="listTitle()"
                           [firstOptionActiveOnInit]="false"
                           [options]="dropdownOptions()"/>
  </ng-template>
</div>
